import {
  Cancel,
  CheckCircle,
  ErrorOutline,
  HourglassEmpty,
} from "@mui/icons-material";
import { Color } from "config/colors";
import { StatusType } from "model/TipCredit";

export const getStatusIcon = (status?: StatusType) => {
  switch (status) {
    case "Approved":
    case "Paid":
      return (
        <CheckCircle
          fontSize="small"
          style={{ color: Color.Success, marginRight: "6px" }}
        />
      );
    case "Failed":
      return (
        <ErrorOutline
          fontSize="small"
          style={{ color: Color.Destructive, marginRight: "6px" }}
        />
      );
    case "Cancelled":
      return (
        <Cancel
          fontSize="small"
          style={{ color: "#7c4dff", marginRight: "6px" }}
        />
      );
    default:
      return (
        <HourglassEmpty
          fontSize="small"
          style={{ color: "#999", marginRight: "6px" }}
        />
      );
  }
};

export const getStatusStyle = (status?: StatusType) => {
  switch (status) {
    case "Approved":
    case "Paid":
      return { color: Color.Success, margin: "0" };
    case "Failed":
      return { color: Color.Destructive, margin: "0" };
    case "Cancelled":
      return { color: Color.SeaBlue600, margin: "0" };
    default:
      return { color: Color.MidnightBlue, margin: "0" };
  }
};
